import { ShareNetwork } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useTranslations } from "use-intl";

export const Brand = () => {
  const t = useTranslations("brand");
  return (
  <Link className="brand" to="/" aria-label={t("home")}>
    <span className="brand-mark" aria-hidden="true"><ShareNetwork size={21} weight="regular" /></span>
    <span>
      <strong>FlowTrace</strong>
      <small>{t("tagline")}</small>
    </span>
  </Link>
  );
};
